import { createApp } from "vue";
import GroupStudentsList from "./components/GroupStudentsList.vue";

const MOUNT_SELECTOR = "[data-vue-group-students-list]";

function getMountElement(container) {
  if (!(container instanceof Element)) {
    return null;
  }

  return container.matches(MOUNT_SELECTOR) ? container : container.querySelector(MOUNT_SELECTOR);
}

export function getGroupStudentsList(container) {
  const element = getMountElement(container);
  if (!element) {
    return null;
  }

  if (element._groupStudentsListComponent) {
    return element._groupStudentsListComponent;
  }

  const app = createApp(GroupStudentsList, {
    apiUrlTemplate: element.dataset.apiUrlTemplate || "",
    schoolId: Number.parseInt(element.dataset.schoolId || "0", 10) || 0,
  });
  const component = app.mount(element);

  element._groupStudentsListApp = app;
  element._groupStudentsListComponent = component;
  element.setAttribute("data-vue-mounted", "1");

  return component;
}

export function loadGroupStudentsList(container, groupId) {
  const component = getGroupStudentsList(container);
  if (!component || typeof component.loadGroupStudents !== "function") {
    return Promise.resolve();
  }

  return component.loadGroupStudents(groupId);
}
